(function () {
  const finishAnimation = (element) => {
    element.__themeAnimation?.cancel();
    element.__themeAnimation = null;
  };

  const slideElement = (element, show, duration = 300) => {
    if (!element) return;
    finishAnimation(element);

    if (show) {
      element.style.display = element.dataset.themeDisplay || "block";
    } else {
      const currentDisplay = getComputedStyle(element).display;
      if (currentDisplay !== "none") element.dataset.themeDisplay = currentDisplay;
    }

    const startHeight = show ? 0 : element.getBoundingClientRect().height;
    const endHeight = show ? element.scrollHeight : 0;
    element.style.overflow = "hidden";

    if (typeof element.animate !== "function") {
      element.style.display = show ? element.dataset.themeDisplay || "block" : "none";
      element.style.removeProperty("height");
      element.style.removeProperty("overflow");
      return;
    }

    const animation = element.animate(
      [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
      { duration, easing: "ease", fill: "forwards" }
    );
    element.__themeAnimation = animation;
    animation.onfinish = () => {
      if (!show) element.style.display = "none";
      element.style.removeProperty("height");
      element.style.removeProperty("overflow");
      element.__themeAnimation = null;
    };
  };

  const fadeElement = (element, show, duration = 400) => {
    if (!element) return;
    finishAnimation(element);
    if (show) element.style.display = element.dataset.themeDisplay || "block";
    else {
      const currentDisplay = getComputedStyle(element).display;
      if (currentDisplay !== "none") element.dataset.themeDisplay = currentDisplay;
    }

    if (typeof element.animate !== "function") {
      element.style.opacity = show ? "1" : "0";
      element.style.display = show ? element.dataset.themeDisplay || "block" : "none";
      return;
    }

    const animation = element.animate(
      [{ opacity: show ? 0 : 1 }, { opacity: show ? 1 : 0 }],
      { duration, easing: "linear", fill: "forwards" }
    );
    element.__themeAnimation = animation;
    animation.onfinish = () => {
      element.style.opacity = show ? "1" : "0";
      if (!show) element.style.display = "none";
      element.__themeAnimation = null;
    };
  };

  const bindAccordion = ({ toggleSelector, itemSelector, itemsSelector, answerSelector }) => {
    document.querySelectorAll(toggleSelector).forEach((toggle) => {
      if (toggle.dataset.nativeAccordionBound === "true") return;
      toggle.dataset.nativeAccordionBound = "true";
      toggle.addEventListener("click", () => {
        const parent = toggle.parentElement;
        if (!parent) return;
        const opening = !parent.classList.contains("active");
        const items = toggle.closest(itemsSelector);

        if (opening) {
          items?.querySelectorAll(`${itemSelector}.active`).forEach((item) => item.classList.remove("active"));
          parent.classList.add("active");
          items?.querySelectorAll(answerSelector).forEach((answer) => slideElement(answer, false));
          slideElement(toggle.nextElementSibling, true);
        } else {
          parent.classList.remove("active");
          slideElement(toggle.nextElementSibling, false);
        }
      });
    });
  };

  const initCollapsibleContent = () => bindAccordion({
    toggleSelector: ".collapsible-content__toggle",
    itemSelector: ".collapsible-content__item",
    itemsSelector: ".collapsible-content__items",
    answerSelector: ".collapsible-content__answer",
  });

  const startGallerySlideshow = (images, gallery) => {
    if (images.length <= 1 || gallery.dataset.nativeGalleryStarted === "true") return;
    gallery.dataset.nativeGalleryStarted = "true";
    const speed = Number(gallery.dataset.speed) * 1000;
    const fadeSpeed = 1000;
    let currentImageIndex = 0;
    fadeElement(images[currentImageIndex], true, fadeSpeed);
    gallery.__themeGalleryInterval = setInterval(() => {
      const nextImageIndex = (currentImageIndex + 1) % images.length;
      fadeElement(images[currentImageIndex], false, fadeSpeed);
      fadeElement(images[nextImageIndex], true, fadeSpeed);
      currentImageIndex = nextImageIndex;
    }, speed);
  };

  const initGallery = () => {
    document.querySelectorAll(".collapsible-content").forEach((section) => {
      const gallery = section.querySelector(".collapsible-content__gallery");
      if (!gallery) return;
      const images = [...gallery.querySelectorAll(".collapsible-content__gallery--image-wrapper")];
      const targets = [...section.querySelectorAll(".observe-me")];
      if (targets.length === 0) {
        startGallerySlideshow(images, gallery);
        return;
      }

      const observer = new IntersectionObserver((entries, instance) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-inview");
          instance.unobserve(entry.target);
          setTimeout(() => {
            entry.target.classList.remove("is-inview", "observe-me");
            startGallerySlideshow(images, gallery);
          }, 600);
        });
      }, { root: null, rootMargin: "0px", threshold: 0.1 });
      targets.forEach((target) => observer.observe(target));
    });
  };

  const initSection = () => {
    initCollapsibleContent();
    initGallery();
  };
  initSection();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSection, { once: true });
  } else {
    initSection();
  }
  document.addEventListener("shopify:section:load", initSection);
})();
